query ProductLineProductPreviews(
    $filter: ProductSearchInput!
    $page: CursorPageSelectionInput
) {
    searchProducts(
        filter: $filter
    ) {
        results(
            page: $page
        ) {
            nodes {
                id
                preview
            }
        }
    }
}
